<span class="p-fluid">
    <p-autoComplete
        #productAutoComplete
        [(ngModel)]="sortiment"
        [suggestions]="filteredProductsMultiple"
        (completeMethod)="filterProductsMultiple($event)"
        styleClass="wid100"
        [minLength]="1"
        placeholder="Produkte"
        field="name"
        optionLabel="name"
        [multiple]="true"
        (keyup.enter)="createNewProduct($event.target.value)"
        (onUnselect)="removeProduct($event.value)"
        (onSelect)="assignExistingProduct($event.value)"
        id="productAutoComplete">
    </p-autoComplete>
</span>
